import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import './DragableElm.scss';

const DraggableEmoji = () => {
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const containerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setViewportSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const emojis = ['🧋', '🎉', '🚀', '🌟'];

  const calculatePosition = (index) => {
    const offset = 100;
    switch (index) {
      case 0:
        return {
          x: viewportSize.width / 1.9 - offset,
          y: viewportSize.height / 1.8 - offset,
        };
      case 1:
        return {
          x: viewportSize.width / 2.5 + offset,
          y: viewportSize.height / 1.9 - offset,
        };
      case 2:
        return {
          x: viewportSize.width / 2.3 - offset,
          y: viewportSize.height / 2.3 + offset,
        };
      case 3:
        return {
          x: viewportSize.width / 2 + offset,
          y: viewportSize.height / 2.3 + offset,
        };
      default:
        return {
          x: viewportSize.width / 2,
          y: viewportSize.height / 2,
        };
    }
  };

  return (
    <div className="emoji-move" ref={containerRef}>
      {emojis.map((emoji, index) => {
        const pos = calculatePosition(index);
        return (
          <motion.div
            key={index}
            className="emoji-move__emoji"
            drag
            dragConstraints={containerRef}
            dragMomentum={false}
            dragElastic={0}
            initial={{ x: pos.x, y: pos.y }}
          >
            {emoji}
          </motion.div>
        );
      })}
    </div>
  );
};

export default DraggableEmoji;